import React from "react";
import PageBackgroundGlow from "../../components/PageBackgroundGlow";
import {useStreamContext} from "../../context/StreamContext";

export default () => {
    const {stream} = useStreamContext();

    return (
        <PageBackgroundGlow color={stream?.color} />
    );
}
